'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _typeof = require('./../../external/@babel/runtime/helpers/esm/typeof.js');
var React = require('react');
var index = require('./../../external/classnames/index.js');
var PropTypes = require('prop-types');
var AccordionItem = require('./AccordionItem/AccordionItem.js');
require('../../sections/Alert/Alert.js');
require('../../sections/Article/Article.js');
require('../../sections/ArticleInfoBlock/ArticleInfoBlock.js');
require('../../sections/Banner/Banner.js');
require('../../sections/BreadCrumbs/BreadCrumbs.js');
require('../../sections/ErrorPage/ErrorPage.js');
require('../../sections/FeatureCarousel/FeatureCarousel.js');
require('../../sections/FeatureCarousel/FeaturedCarouselItem/FeaturedCarouselItem.js');
require('../../sections/FeaturedMarquee/FeaturedMarquee.js');
require('../../sections/NewsletterSubscription/NewsletterSubscription.js');
require('../../sections/OpenPositions/OpenPositions.js');
require('../../sections/OurTeam/OurTeam.js');
require('../../sections/PageHeader/PageHeader.js');
require('../../sections/Pagination/Pagination.js');
require('../../sections/PaginationContainer/PaginationContainer.js');
require('../../sections/PanelGroup/PanelGroup.js');
require('../../sections/PanelGroup/Panel/Panel.js');
require('../../sections/PodcastCarousel/PodcastCarousel.js');
require('../../sections/SecondaryNav/SecondaryNav.js');
var Section = require('../../sections/Section/Section.js');
require('../../sections/Section/SectionHeader/SectionHeader.js');
require('../../sections/SplitBanner/SplitBanner.js');
require('../../sections/SplitBanner/SplitBannerImage/SplitBannerImage.js');
require('../../sections/SplitBanner/SplitBannerVideo/SplitBannerVideo.js');
require('../../sections/SplitBanner/SplitBannerContent/SplitBannerContent.js');
require('../../sections/SplitBanner/SplitBannerContact/SplitBannerContact.js');
var slugify = require('../../utilities/slugify.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var Accordion = function Accordion(_ref) {
  var id = _ref.id,
    accordionItems = _ref.accordionItems,
    className = _ref.className,
    heading = _ref.heading,
    isLinkable = _ref.isLinkable,
    isReact = _ref.isReact,
    startOpen = _ref.startOpen;
  var accordionClasses = index.default('lanl-accordion', className);
  var titles = accordionItems.map(function (_ref2) {
    var title = _ref2.title;
    return slugify.slugify(title);
  });
  var duplicates = titles.filter(function (title, index) {
    return title && titles.indexOf(title) !== index;
  });
  if (duplicates.length > 0) {
    throw new Error("Accordion titles must be unique when slugified. The following slugified titles are duplicated: ".concat(duplicates.join(', '), ". The heading for the accordion is: ").concat(heading));
  }
  return /*#__PURE__*/React__default.default.createElement(Section.Section, {
    id: id,
    isLinkable: isLinkable,
    noStyling: true
  }, /*#__PURE__*/React__default.default.createElement("div", {
    className: accordionClasses,
    "data-testid": "lanl-accordion"
  }, heading !== '' && /*#__PURE__*/React__default.default.createElement("h3", {
    className: "accordion-title"
  }, heading), accordionItems.map(function (_ref3, index) {
    var title = _ref3.title,
      content = _ref3.content;
    return /*#__PURE__*/React__default.default.createElement(AccordionItem.AccordionItem, {
      key: "accordion-item-".concat(slugify.slugify(title)),
      id: "".concat(slugify.slugify(title)),
      title: title,
      content: content,
      open: startOpen && index === 0,
      isReact: isReact
    });
  })));
};
Accordion.defaultProps = {
  id: null,
  accordionItems: [],
  classNames: '',
  isLinkable: false,
  isReact: false,
  startOpen: false
};
Accordion.propTypes = {
  accordionItems: PropTypes__default.default.arrayOf(PropTypes__default.default.shape({
    content: PropTypes__default.default.string.isRequired,
    title: PropTypes__default.default.string.isRequired
  })).isRequired,
  className: PropTypes__default.default.string,
  heading: PropTypes__default.default.string,
  id: function id(props, propName, componentName) {
    if (props['isLinkable'] && !props[propName]) {
      return new Error('id prop is required if isLinkable prop is true');
    }
    if (props[propName] && typeof props[propName] !== 'string') {
      return new Error("Invalid prop id of type '".concat(_typeof.default(props[propName]), "' supplied to '").concat(componentName, "', expected 'string' "));
    }
  },
  isLinkable: PropTypes__default.default.bool,
  isReact: PropTypes__default.default.bool,
  startOpen: PropTypes__default.default.bool
};

exports.Accordion = Accordion;
exports.default = Accordion;
//# sourceMappingURL=Accordion.js.map
